






import { Component, Vue, Prop } from 'vue-property-decorator'
import CmmdtyItem from './recommend_item_cmmdty.vue'
import ShopItem from './recommend_item_shop.vue'
import TopicItem from './recommend_item_topic.vue'
import TeacherItem from './recommend_item_teacher.vue'
import CommentItem from './recommend_item_comment.vue'
import ActivityItem from './recommend_item_activity.vue'
import AdvertiseItem1 from './recommend_item_advertise1.vue'
import AdvertiseItem2 from './recommend_item_advertise2.vue'
import AdvertiseItem3 from './recommend_item_advertise3.vue'
import { level4CategoryIdIsSendForm, creatCollectForm } from '../search/utils'
import { searchToWhereUrl } from '@core/utils/jump'
import { cookies } from '@utils/index'

@Component({
  components: {
    CmmdtyItem,
    ShopItem,
    TopicItem,
    TeacherItem,
    CommentItem,
    ActivityItem,
    AdvertiseItem1,
    AdvertiseItem2,
    AdvertiseItem3,
  },
})
export default class RecommendItem extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any
  @Prop({}) readonly moduleId!: string
  @Prop({ default: () => ({}) }) readonly tab!: any

  showItem = false
  intersectionObserver: IntersectionObserver | any = null

  get recommendItemComp() {
    if (this.moduleId == '1001') {
      /* 商品 */
      return 'CmmdtyItem'
    } else if (this.moduleId == '1002') {
      /* 商户 */
      return 'ShopItem'
    } else if (this.moduleId == '1003') {
      /* 话题 */
      return 'TopicItem'
    } else if (this.moduleId == '1004') {
      /* 老师 */
      return 'TeacherItem'
    } else if (this.moduleId == '1005') {
      /* 商品评价 */
      return 'CommentItem'
    } else if (this.moduleId == '1006') {
      /* 互动活动 */
      return 'ActivityItem'
    } else if (this.moduleId == '1007') {
      /* 广告 */
      if (this.value.feedType == 1) {
        /* 图片广告 */
        return 'AdvertiseItem1'
      } else if (this.value.feedType == 2) {
        /* 商家广告 */
        return 'AdvertiseItem2'
      } else if (this.value.feedType == 3) {
        /* 榜单广告 */
        return 'AdvertiseItem3'
      }
    }
  }

  mounted() {
    /* 使用IntersectionObserver判断元素是否在视窗中，实现懒加载元素（暂时不用） */
    if (false && IntersectionObserver) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        // If intersectionRatio is 0, the target is out of view
        // and we do not need to do anything.
        if (entries[0].intersectionRatio <= 0) return

        console.log('Loaded new recommendItem')
        this.showItem = true
        this.intersectionObserver.unobserve(<Element>this.$refs.recommendItem)
      })
      // start observing
      this.intersectionObserver.observe(<Element>this.$refs.recommendItem)
    } else {
      this.showItem = true
    }
  }

  async creatCollect() {
    if (this.moduleId == '1007') {
      if (this.level4CategoryIds && this.level4CategoryIds.length) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const data = {
          categoryId: this.level4CategoryIds,
          utm: 'xxlgg', // 搜索渠道码写死xxlgg
        }
        await creatCollectForm(data)
      }
      window.location.href = this.linkUrl
    }
  }

  kwtarget(url: string | undefined) {
    if (url) {
      url = String(url)
      const idx = url.indexOf('?')
      if (idx < 0) {
        url += '?'
      } else if (idx >= 0 && idx != url.length - 1) {
        url += '&'
      }
      url += 'kwtarget=blank'
      return url
    }
    return ''
  }

  get level4CategoryIds() {
    return level4CategoryIdIsSendForm(this.value.level4CategoryLimit)
  }

  get linkUrl() {
    if (this.value.feedType == 2) {
      const { bid } = this.value
      return this.kwtarget(searchToWhereUrl({ toShop: true, businessId: bid }))
    }
    return this.kwtarget(this.value.linkUrl)
  }

  beforeDestory() {
    this.intersectionObserver = null
  }
}
